import { Alert } from "antd";
import * as Sentry from "@sentry/react";

const ApErrorBoundary = import.meta.env.VITE_MODE === "production" ? Sentry.ErrorBoundary : Alert.ErrorBoundary;

export default ApErrorBoundary;